import React from "react";
//import BannerCarousel from "../../Componentes/BannerCarousel";
import "./Home.css";
//import { CCarousel, CCarouselCaption, CCarouselItem, CImage } from '@coreui/react'
import '@coreui/coreui/dist/css/coreui.min.css'
//import HorarioAtendimento from "../../Componentes/HorarioAtendimento";
import { UiChecksGrid } from 'react-bootstrap-icons';
import MudaPagina from "../../Componentes/Util/Navegacao"

const Home = () =>{

    return (
        <div className="home">
            {/* <BannerCarousel banners={[
                {urlArea:"/imagens/Banner_transparent.png", url:"/imagens/Home/pedreiro_home.jpg", height:"986px", descricao:"Imagens 002"}
            ]} /> */}
            {/* <HorarioAtendimento></HorarioAtendimento> */}
            <div className="areaUtil-banners" style={{background:`url(/imagens/Home/home_oficial_construmarcas-002.jpg)`}}>
                <header>
                    <div className="conteudo">
                        {/* <img className="logo" src="/lgCM.svg" /> */}
                        {/* <h3>
                            <b><i>Há mais de 20 anos</i></b> abastecendo com produtos de qualidade as melhores lojas de materiais de construção do brasil.
                        </h3> */}
                        {/* <div className="frase-impacto">
                            <span className="destaque-texto">A MARCA</span> <span className="titulo">DO</span>
                            <br /><span className="titulo">CONSTRUTOR</span>
                        </div> */}
                    </div>
                </header>
                <div style={{"maxHeight":"986px", "overflow": "hidden"}}>
                    <img alt="Construmarcas, qualidade garantida em todos os nossos produtos." src="/imagens/Home/Banner_transparent_home_002.png" />
                </div>
            </div>
            {/* <div className="conteudo">
                <div className="menu-home" onClick={() => MudaPagina('/produtos')}>
                    <div>
                        <div className="listra-01"></div>
                        <div className="rotulo">
                            <span>CATÁLOGO DE</span>
                            <br /><span>PRODUTOS</span>
                            <br /><br />Confira toda a linha de produtos <b>Construmarcas</b>
                        </div>
                    </div>
                    <div className="icone">
                        <UiChecksGrid size={80} />
                        <br /><br /><div>Clique aqui para acessar o catálogo</div>
                    </div>
                </div>                
            </div> */}
            <div className="conteudo-001">
                <div className="listra-02"></div>
                <div className="conteudo">
                    <div className="frase-impacto">
                        <span className="destaque-texto">A MARCA</span> <span className="titulo">DO</span>
                        <br /><span className="titulo">CONSTRUTOR</span>
                    </div>
                    <br /><span>Qualidade garantida em todos os nossos produtos, a <b>Construmarcas</b> está presente nas melhores lojas de materiais de construção. <b>Confira!!!</b></span>
                </div>
            </div>
            <div className="conteudo-002">
                {/* <div className="listra-02"></div> */}
                <div className="conteudo">
                    <div className="frase-impacto">
                        <span className="destaque-texto">GRUPO</span>
                        <br /><span className="titulo">CONSTRUMARCAS</span>
                    </div>
                    <br /><span>A <b>CONSTRUMARCAS</b> é um grupo de indústrias que tem uma distribuição em comum, com objetivo de ser mais competitivo e oferecer um atendimento especializado.</span>
                </div>
            </div>
        </div>
    )
}
export default Home;